import { useQuery } from '@tanstack/react-query';
import { WEBSITE_HERO_SOURCE_ENABLED } from '../config/websiteHero';
import { getWebsiteHeroMedia } from '../services/websiteHero.service';

export const websiteHeroMediaKey = ['website', 'hero-media'] as const;

/** Public website catalogue only; disabled builds never read either catalogue. */
export function useWebsiteHeroMedia() {
  return useQuery({
    queryKey: websiteHeroMediaKey,
    enabled: WEBSITE_HERO_SOURCE_ENABLED,
    queryFn: () => {
      // Also guard imperative refetch(), which bypasses Query's enabled flag.
      if (!WEBSITE_HERO_SOURCE_ENABLED) return Promise.resolve([]);
      return getWebsiteHeroMedia();
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
